export const RestrictCardDetail = "RESTRICT_CARD_DETAIL";
export const DineInCoverDetail = "COVER_POPUP";
export const PickupCustomerDetail = "CUSTOMER_POPUP";
export const HideItemComments = "HIDE_ITEM_COMMENT_PRINT";
export const HideDealItems = "HIDE_DEAL_ITEMS_PRINT";
export const AllowNegativeStockIssuance = "ALLOW_NEGATIVE_STOCK_ISSUANCE";
export const AllowIssuanceWithoutDemand = "ALLOW_ISSUANCE_WITHOUT_DEMAND";
export const AllowGrnWithoutPo = "ALLOW_GRN_WITHOUT_PO";
export const RestrictBranchToChangeOrderStatus = "RESTRICT_BRANCH_TO_CHANGE_ORDER_STATUS";
